import { Injectable } from '@angular/core';

import authHeader from '../helpers/auth-header';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import axios from 'axios';
import { UserProfile } from '../interfaces/UserProfile';
import { catchError, map } from 'rxjs';


@Injectable({
     providedIn: 'root'
})
export class UserManagementService {

     constructor(private http: HttpClient) { }
     getUsersForCustomer() {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };

          const url = `${environment.APP_API_URL}/api/v1/UserManagement/GetUsersForCustomer`;
          return this.http.get(url, config)
          .pipe(
               map((response: any) => response),
               catchError(error => {
                    console.error(error);
                    return [];
               })
           );
     }

     disableUser(username: string) {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };

          const url = `${environment.APP_API_URL}/api/v1/UserManagement/DisableUser?username=${username}`;
          return this.http.post(url, null, config)
          .pipe(
               map((response: any) => response),
               catchError(error => {
                    console.error(error);
                    return [];
               })
           );
     }

     getUserProfile(username: string) {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };

          const url: string = `${environment.APP_API_URL}/api/v1/UserManagement/GetUserProfile?username=${username}`;
          return this.http.get(url, config)
          .pipe(
               map((response: any) => response),
               catchError(error => {
                    console.error(error);
                    return [];
               })
           );
     }

     getAvailableRoles() {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };

          const url: string = `${environment.APP_API_URL}/api/v1/UserManagement/GetAvailableRoles`;
          return this.http.get(url, config)
          .pipe(
               map((response: any) => response),
               catchError(error => {
                    console.error(error);
                    const errorMessage = error.response.statusText;
                    return [errorMessage];
               })
           );
     }

     
}
